/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-22 10:35:38
 * @LastEditTime: 2019-09-23 11:00:05
 * @LastEditors: Please set LastEditors
 */
import styled, { css } from 'styled-components'
import { Head, media } from '../../../styles'
import { Button, Switch } from 'antd'

import { styleguide } from '../../../constants'

const { colors, typography } = styleguide

export const HeadWrap = styled(Head)`
  display: flex;
  justify-content: space-between;
  position: relative;
  top: -20px;
  background: white;
  // border-bottom: 1px solid ${colors.darkGreyThree};
  padding-bottom: 0;

  
  .ant-icon svg {
    height: auto !important;
    width: auto !important;
  }

  ${props =>
    props.isFullscreen &&
    css`
      margin-bottom: 0;
      top: -10px;
    `}
`

export const CourseContent = styled.section`
  padding: 0 3.2rem 10rem;
  display: flex;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-between;
  margin-top: 2rem;

  ${media.md`
    flex-direction: column;
      padding: 0 2rem 5rem;
  `}
`

export const CourseOwner = styled.section`
  padding: 0 3.2rem;
`

CourseOwner.Name = styled.p`
  font-size: 1.1rem;
  text-transform: uppercase;
  font-weight: 300;
  width: 100%;
  margin: 0;
  padding-bottom: 1.1rem;
  border-bottom: 1px solid ${colors.darkGreyThree} span {
    font-weight: ${typography.h3FontWeight};
  }
`

export const PanelWrapp = styled.div`
  display: flex;
  align-content: flex-start;
  justify-content: space-between;
`

export const PanelItem = styled.div`
  width: 100%;
  padding: 3rem;
  border: 0.1rem solid ${colors.darkGreyThree};

  ${media.md`
     padding: 1rem;
  `}
`

PanelItem.Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${media.sm`
    flex-direction: column;
  `}
`

PanelItem.Title = styled.h2`
  font-weight: 600;
  font-size: 2rem;
  letter-spacing: 0.05em;
  margin-bottom: 2rem;
  color: ${colors.darkGreyOne};
`

PanelItem.Content = styled.div`
  border-top: 0.1rem solid #ddd;
  padding-top: 2.5rem;
`

PanelItem.Description = styled.p`
  font-weight: 300;
  line-height: 2.4rem;
  margin-bottom: 2rem;
`

PanelItem.Image = styled.img`
  width: 100%;
  aspect-ratio: 16/9;
  object-fit: contain;
`

export const LessonsBlock = styled.div`
  width: 30%;
  flex-basis: 30%;
  padding-top: 6.7rem;
  margin-left: 1.5rem;

  & > div {
    padding: 0;
  }

  ${media.md`
    width: 100%;
    margin-left: 0;
    padding-top: 2.9rem;
  `}
`

export const Footer = styled.section`
  height: 7rem;
  border-top: 0.1rem solid #eeeeee;
  width: 100vw;
  position: fixed;
  bottom: 0;
  left: 0;
  background-color: #fff;
  padding: 0 4rem;
  ${media.md`
    height: 100%;
    position: static;
    width: 100%;
  `}
`

Footer.Wrapp = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
  ${media.md`
       flex-direction: column;
    gap: 12px;
    padding: 15px;
  `}

  .ant-btn {
    margin-right: 0.8rem;

    &:last-child {
      margin-right: 0;
    }
  }
`

export const CourseExpire = styled.span`
  color: red;
  font-weight: ${typography.h2FontWeight};
  margin-right: 6rem;
`

export const ZoomBtnGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  background: #f4f5fa;
  padding: 1rem;
  height: max-content;
  border-radius: 29px;
  ${media.sm`
    flex-direction: column;
  `}

  .ant-radio-button-wrapper:first-child {
    border-radius: 50px 0 0 50px;
  }

  .ant-radio-button-wrapper:last-child {
    border-radius: 0 50px 50px 0;
  }
`

export const ZoomBtn = styled(Button)`
  display: flex;
  align-items: center;
  &.ant-btn {
    height: 32px !important;
  }
  &:last-child {
    margin-right: 0;
  }
`

export const Btn = styled(Button)`
  && {
    width: 15rem;
    height: 4rem;
    font-weight: ${typography.h2FontWeight};

    ${props =>
      props.startlesson &&
      css`
        background-color: ${colors.green} !important;
        border-color: ${colors.green} !important;
        display: flex;
        align-items: center;
        justify-content: space-around;
      `}
  }
`
export const Switched = styled(Switch)`
  && {
    ${props =>
      props.startlesson &&
      css`
        background-color: ${colors.green} !important;
        border-color: ${colors.green} !important;
        display: flex;
        align-items: center;
        justify-content: space-around;
      `}
  }
`

export const PageWrapper = styled.div`
  resize: both;
  position: relative;
  margin: 3rem 0 0 0;
  .el__preview {
    background: rgba(255, 255, 255, 0);
  }
`
export const AnnotationPageWrapper = styled.div`
  position: relative;
  margin: 3rem 0 0 0;
  .el__preview {
    background: rgba(255, 255, 255, 0);
  }
  height: 100%;
  min-height: 560px;
`

export const LandscapePageWrapper = styled.div`
  position: relative;
  .el__preview {
    background: rgba(255, 255, 255, 0);
  }
  overflow: hidden;
`
export const PageContent = styled.section`
  position: relative;
  width: 100%;
  min-height: 1024px;
  height: 100%;
  border: 1px solid ${colors.light};
  background-color: ${colors.white};
  overflow: auto;
  top: -35px;
`

export const LandscapePageContent = styled.section`
  position: relative;
  width: 1023px;
  height: 552px;
  border: 1px solid #e3e3e3;
  background-color: ${colors.white};
  border-radius: 8px;
  overflow: hidden;

  ${props =>
    props.loading &&
    css`
      display: flex;
      align-items: center;
      justify-content: center;
    `}

  ${props =>
    props.isFullscreen &&
    css`
      height: 100%;
      width: 100%;
    `}
`
